<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表-添加管理员
    -->
  <div>
  <el-dialog title="会员等级" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">
      <el-form-item label="用户名" prop="user_name">
        <el-input v-model="form.user_name" placeholder="请输入用户名">
        </el-input>
      </el-form-item>
      <el-form-item label="所属角色" prop="role_id">
        <el-select v-model="form.role_id" :multiple="true">
          <el-option v-for="item in roleList" :value="item.role_id" :key="item.role_id" :label="item.role_name_h1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="登录密码" prop="password"><el-input v-model="form.password" placeholder="请输入登录密码" type="password"></el-input></el-form-item>
      <el-form-item label="确认密码" prop="confirm_password"><el-input v-model="form.confirm_password" placeholder="请输入确认密码" type="password"></el-input></el-form-item>
      <el-form-item label="姓名" prop="real_name"><el-input v-model="form.real_name"></el-input></el-form-item>
      <el-form-item label="关联门店">
        <el-row>
          <el-tag
            style="margin-left: 10px;"
            :key="tag.store_id"
            size="small"
            v-for="tag in form.admin_store"
            closable @close="handleDeleteStore(tag)">{{tag.store_name}}</el-tag>
          <el-button icon="el-icon-plus" @click="addShopClick">关联门店</el-button>
          <div class="lh18 mt10 gray9">
            <p>注：不关联门店，可查看所有门店订单信息。</p>
            <p>关联门店，则可查看对应门店的订单信息</p>
          </div>
        </el-row>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
    <ShopSelect :isstore="open_shop_select" :hasSelected="form.admin_store"  @close="closeShopSelect"></ShopSelect>
  </div>

  <!--添加-->
</template>



<script>
import AuthApi from '@/api/auth.js';
import ShopSelect from '@/components/shop/shopSelect';

export default {
  components: {
    /*编辑组件*/
    ShopSelect
  },
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
      /*form表单对象*/
      form: {
        user_name: '',
        access_id: [],
        admin_store:[]
      },
      /*form验证*/
      formRules: {
        user_name: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        role_id: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        confirm_password: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        real_name: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ]
      },
      open_shop_select: false
    };
  },
  props: ['open', 'roleList'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    }
  },
  created() {},
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      AuthApi.userAdd(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，添加成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    },
    /*关闭获取用户弹窗*/
    closeShopSelect(e) {
      if (e.type =='success'){
        this.form.admin_store = e.params.map(function (item) {
          return {
            store_id:item.store_id,
            store_name:item.store_name
          }
        })
      }
      this.open_shop_select = false;
    },
    addShopClick() {
      this.open_shop_select = true;

    },
    handleDeleteStore(tag){
      this.form.admin_store.splice(this.form.admin_store.indexOf(tag), 1);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/auth/user/dialog/Add.vue